module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-list', {
    staticClass: "hotelList"
  }, _vm._l((_vm.HotelList), function(item) {
    return _c('mu-list-item', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "titleClass": "title"
      },
      on: {
        "click": function($event) {
          return _vm.choose(item.HotelCode)
        }
      }
    }, [_c('div', {
      style: ('background: url(' + item.HotelImg + ')   ;   background-size:cover;  float:left ; width: 2.12rem ; height: 1.59rem;  font-size:0.18rem; min-height:0.7rem ; ')
    }, [(item.LabelTop) ? _c('div', {
      staticStyle: {
        "position": "absolute",
        "background-color": "red",
        "color": "white",
        "padding": "0 0.05rem"
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.LabelTop) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.LabelBottom) ? _c('span', {
      staticStyle: {
        "width": "2.12rem",
        "height": "0.32rem",
        "text-align": "center",
        "top": "1.45rem",
        "position": "absolute",
        "color": "white",
        "background": "url(../../../static/search/pic_bg.png) repeat-x"
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.LabelBottom) + "\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "68%",
        "float": "right",
        "margin-top": "-0.08rem"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "color": "#777",
        "font-size": "0.28rem",
        "line-height": "0.4rem"
      }
    }, [_vm._v("\n          " + _vm._s(item.HotelName) + "\n        ")]), _vm._v(" "), (_vm.showAddress) ? _c('div', {
      staticClass: "hotelLoc",
      staticStyle: {
        "white-space": "nowrap",
        "margin": "0.1rem 0"
      }
    }, [_c('mu-icon', {
      staticStyle: {
        "position": "relative"
      },
      attrs: {
        "value": "room",
        "color": "#A5A5A5",
        "size": 13
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "4.3rem",
        "height": "0.5rem"
      }
    }, [_vm._v(" " + _vm._s(item.Address) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showCommonts) ? _c('div', [_vm._v(_vm._s(item.CommentCount) + "条评论")]) : _vm._e(), _vm._v(" "), (item.ListGreen.length == 0 && item.ListYellow.length == 0 && !item.BBreak && !item.BRoom) ? _c('div', {
      staticStyle: {
        "height": "0.4rem"
      }
    }) : _vm._e(), _vm._v(" "), _c('stars', {
      attrs: {
        "score": item.CommentScore
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "0.3rem"
      }
    }, _vm._l((item.HotelServiceList), function(ser) {
      return _c('img', {
        class: _vm.serviceIcon(ser.KeyId),
        attrs: {
          "src": '../../../static/service/' + _vm.serviceIcon(ser.KeyId) + '.png'
        }
      })
    }), 0), _vm._v(" "), (item.LowestPrice != '满房') ? _c('span', {
      staticClass: "lowestPrice",
      class: {
        'upgap': item.LabelCount > 3
      }
    }, [_c('span', {
      staticClass: "priceSign"
    }, [_vm._v("￥ ")]), _vm._v(" "), _c('span', {
      staticClass: "priceShow"
    }, [_vm._v(_vm._s(item.LowestPrice))]), _vm._v(" "), _c('span', {
      staticClass: "priceTxt"
    }, [_vm._v(" 起")])]) : _vm._e(), _vm._v(" "), (item.LowestPrice == '满房') ? _c('span', {
      staticClass: "lowestPrice",
      class: {
        'upgap': item.LabelCount > 3
      }
    }, [_c('span', {
      staticClass: "priceShow"
    }, [_vm._v(_vm._s(item.LowestPrice))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "0.18rem",
        "line-height": "0.6rem",
        "width": "100%"
      }
    }, [(item.BBreak) ? _c('span', {
      staticClass: "GreenLabel"
    }, [_vm._v("早餐购")]) : _vm._e(), _vm._v(" "), (item.BRoom) ? _c('span', {
      staticClass: "GreenLabel"
    }, [_vm._v("自助选房")]) : _vm._e(), _vm._v(" "), (item.ListYellow[0] != null) ? _c('span', {
      staticClass: "YelloLabel"
    }, [_vm._v(_vm._s(item.ListYellow[0]))]) : _vm._e(), _vm._v(" "), (item.ListYellow[1] != null) ? _c('span', {
      staticClass: "YelloLabel"
    }, [_vm._v(_vm._s(item.ListYellow[1]))]) : _vm._e(), _vm._v(" "), (item.ListGreen[0] != null) ? _c('span', {
      staticClass: "GreenLabel"
    }, [_vm._v(_vm._s(item.ListGreen[0]))]) : _vm._e(), _vm._v(" "), (item.ListGreen[1] != null) ? _c('span', {
      staticClass: "GreenLabel"
    }, [_vm._v(_vm._s(item.ListGreen[1]))]) : _vm._e(), _vm._v(" "), (item.LabelBack) ? _c('span', {
      staticClass: " BackLabel ",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v("\n            " + _vm._s(item.LabelBack) + "\n          ")]) : _vm._e()])], 1)])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-095536ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hotelList.vue
// module id = 1412
// module chunks = 18